import RestClient from './rest-client'

export default class User extends RestClient {
  static get url () {
    return this.apiUrl + '/users'
  }
  
  static get paramKey () {
    return 'user'
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }

  async confirmEmail () {
    await this.constructor._put(this.constructor.url + `/${this.id}/confirm`)

    return true
  }

  static async exportTransactions (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/export_users_transactions`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

  async updateFiscalDataVerified (id) {
    const { data } = await this.constructor._post(this.constructor.url + `/${id}/update_fiscal_data_verfied`)

    return data
  }

  static async updatePreference (payload) {
    const { data } = await this._post(this.url + '/update_preference', {preference: payload})
    return data
  }
}
